var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLotteryCageBalls = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 241 146"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#90F6DF",
  d: "M97.715 103.75s-.934 16.066-7.389 30.499l5.788 4.898c.92.778.369 2.28-.835 2.28H66.646l.555-37.752 30.512.076z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#C3FBF1",
  d: "M71.409 103.663s-6.054 21.359-14.027 30.527l5.787 4.898c.92.778.37 2.28-.834 2.28l-25.632.118H32.69c4.344-19.806 4.56-37.676 4.56-37.676l34.16-.146z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#C3FBF1",
  d: "M26.594 105.15h77.594c5.528 0 10.009-4.481 10.009-10.009V28.91c0-5.528-4.481-10.01-10.009-10.01H26.594c-5.528 0-10.01 4.482-10.01 10.01V95.14c0 5.528 4.482 10.009 10.01 10.009"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#90F6DF",
  d: "M37.111 105.15H26.795c-5.636 0-10.211-4.575-10.211-10.21V28.126c0-5.091 4.135-9.226 9.227-9.226H37.11v86.25z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#FF662F",
  d: "m54.277 4.92 5.334 2.608c.505.382 1.363.236 1.602-.275l4.465-6.48c.484-1.031 2.409-1.031 2.892 0l4.586 6.523c.239.51 1.098.657 1.602.275l5.37-2.716c.61-.463 1.656-.136 1.657.52l-4.293 9.392c0 .593-.828.76-1.518.738L58.492 15.5c-.704.034-1.494-.05-1.487-.63l-4.384-9.436c.01-.65 1.05-.973 1.658-.512z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#4A4A4A",
  d: "M72.281 54.2c0 5.166 4.189 9.354 9.354 9.354a9.354 9.354 0 0 0 9.353-9.353 9.3 9.3 0 0 0-.954-4.122H73.235a9.3 9.3 0 0 0-.954 4.122m4.036 4.648s2.073-1.26 4.058-.717c1.983.542 3.126 2.682 3.126 2.682s-2.072 1.258-4.055.716-3.127-2.681-3.127-2.681z"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  stroke: "#4A4A4A",
  strokeMiterlimit: 10,
  strokeWidth: 0.994,
  d: "M57.978 60.394c8.428 0 15.26-6.832 15.26-15.26 0-8.427-6.832-15.259-15.26-15.259-8.427 0-15.26 6.832-15.26 15.26 0 8.427 6.833 15.26 15.26 15.26ZM104.867 60.394c8.427 0 15.259-6.832 15.259-15.26 0-8.427-6.832-15.259-15.259-15.259-8.428 0-15.26 6.832-15.26 15.26 0 8.427 6.832 15.26 15.26 15.26ZM16.765 52.91C-8.555 69.86.081 92.446 13.098 95.83c9.458 2.457 20.493-.935 23.897-8.269 1.997-4.3 1.765-7.788-1.727-10.246-2.06-1.45-7.111-2.999-7.525.125-.192 1.453 1.736 1.88 2.325 2.173 1.226.606 1.313 1.623.823 2.9"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  stroke: "#4A4A4A",
  strokeMiterlimit: 10,
  strokeWidth: 0.994,
  d: "M32.363 75.977c-2.374-2.808-.948-7.08-2.853-10.393-1.257-2.188-2.025-.005-2.443 2.142-.55 2.823.042 6.987.678 9.714"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  stroke: "#4A4A4A",
  strokeMiterlimit: 10,
  strokeWidth: 0.994,
  d: "M24.236 76.497c.693-.732 1.995-2.076 2.834-2.843M30.541 71.399c.94-.974.557-.705 2.135-2.461 1.343-1.493 2.945.14 2.575 1.223-.647 1.893-3.3 4.039-3.505 4.912"
})), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
  stroke: "#4A4A4A",
  strokeMiterlimit: 10,
  strokeWidth: 0.994,
  d: "M21.565 77.72c.555-.88 1.318-1.411 2.142-1.386 1.053.036 1.944.972 2.404 2.346.24.71.363 1.54.335 2.417a7 7 0 0 1-.43 2.234c-.54 1.428-1.523 2.375-2.615 2.339-.675-.023-1.281-.415-1.751-1.053"
})), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
  stroke: "#4A4A4A",
  strokeMiterlimit: 10,
  strokeWidth: 0.994,
  d: "M22.554 81.43c.085-2.579-1.141-4.712-2.739-4.764s-2.961 1.995-3.046 4.573 1.141 4.71 2.739 4.763 2.96-1.994 3.046-4.572ZM118.054 52.91c16.62 10.647 16.871 33.095 4.116 41.148-8.264 5.218-20.128 1.928-23.532-5.405-1.997-4.3-1.765-7.789 1.728-10.247 2.06-1.45 7.11-2.998 7.524.126.193 1.453-1.735 1.88-2.325 2.172-1.226.607-1.313 1.623-.823 2.9"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  stroke: "#4A4A4A",
  strokeMiterlimit: 10,
  strokeWidth: 0.994,
  d: "M103.27 77.068c2.374-2.807 2.386-5.444 5.178-7.632 1.986-1.557 3.175.082 2.443 2.143-.944 2.655-2.365 4.228-3.001 6.954"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  stroke: "#4A4A4A",
  strokeMiterlimit: 10,
  strokeWidth: 0.994,
  d: "M111.394 77.589a44 44 0 0 0-2.279-2.252M106.024 72.223c-.939-.974-1.303-1.745-2.882-3.499-1.342-1.493-2.944.14-2.574 1.223.646 1.893 3.119 4.607 3.988 5.604"
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  stroke: "#4A4A4A",
  strokeMiterlimit: 10,
  strokeWidth: 0.994,
  d: "M114.065 78.811c-.555-.88-1.318-1.41-2.143-1.385-1.052.035-1.944.972-2.404 2.346-.24.71-.363 1.54-.334 2.417.027.814.18 1.576.43 2.234.54 1.427 1.523 2.374 2.614 2.338.675-.022 1.282-.415 1.752-1.052"
})), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
  stroke: "#4A4A4A",
  strokeMiterlimit: 10,
  strokeWidth: 0.994,
  d: "M116.134 87.088c1.597-.053 2.823-2.186 2.738-4.764s-1.449-4.626-3.046-4.573-2.823 2.185-2.738 4.764c.085 2.578 1.449 4.625 3.046 4.573Z"
})), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
  fill: "#F6F6F6",
  d: "M193.618 118.479c25.696 0 46.526-20.83 46.526-46.527 0-25.695-20.83-46.526-46.526-46.526s-46.526 20.83-46.526 46.526 20.83 46.527 46.526 46.527"
})), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
  fill: "#B5BCFF",
  d: "M210.833 100.991a8.61 8.61 0 1 0 0-17.218 8.61 8.61 0 0 0 0 17.218M187.368 105.654a8.608 8.608 0 1 0-8.608-8.608 8.61 8.61 0 0 0 8.608 8.608M225.314 83.58a8.61 8.61 0 0 0 8.608-8.608 8.608 8.608 0 1 0-8.608 8.608"
})), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
  fill: "#B5BCFF",
  d: "M215.103 77.892a8.61 8.61 0 0 0 8.608-8.609 8.609 8.609 0 1 0-8.608 8.609M170.153 63.53a8.608 8.608 0 1 0 .001-17.217 8.608 8.608 0 0 0-.001 17.217M185.009 80.56a8.61 8.61 0 0 0 8.608-8.608 8.608 8.608 0 1 0-17.217 0 8.61 8.61 0 0 0 8.609 8.609"
})), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
  fill: "#8591FE",
  d: "M208.097 115.417a8.61 8.61 0 0 0 8.608-8.609 8.61 8.61 0 0 0-8.608-8.608 8.608 8.608 0 1 0 0 17.217M189.378 116.973a8.61 8.61 0 0 0 0-17.217 8.609 8.609 0 0 0 0 17.217"
})), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
  fill: "#8591FE",
  d: "M175.452 112.536a8.608 8.608 0 1 0 0-17.217 8.608 8.608 0 0 0 0 17.217M227.493 97.047a8.609 8.609 0 1 0 0-17.217 8.609 8.609 0 0 0 0 17.217"
})), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
  fill: "#90F6DF",
  d: "M220.191 41.615c-6.476.009-9.368 1.556-9.389 10.128.021-8.572-4.163-10.128-9.325-10.139 5.068.01 9.325-.86 9.325-10.118 0 9.258 2.913 10.138 9.389 10.129"
})), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
  fill: "#E1E1E1",
  d: "M193.455 144.866c19.859 0 35.958-3.743 35.958-8.359 0-4.617-16.099-8.36-35.958-8.36-19.86 0-35.959 3.743-35.959 8.36s16.099 8.359 35.959 8.359"
})), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
  fill: "#C8C8C8",
  d: "M223.863 136.507c-3.052 3.261-44.016 7.338-60.818 0l7.657-24.155c18.678 6.636 27.285 6.623 45.739.317z"
})), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
  stroke: "#4A4A4A",
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  strokeWidth: 0.905,
  d: "m98.068 46.315 3.799-2.895M98.057 46.375l5.51-.12M62.193 46.315l-3.8-2.895M62.203 46.375l-5.51-.12"
})));
export default SvgLotteryCageBalls;